import React, { useState } from "react";
import '../../components/bracket/BracketDisplay.css';
import './CreateBracketPage.css';
import {generateUUID} from "../../utilities/js/UUIDGenerator";
import SettingsPanel from "./SettingsPanel";
import BracketContainer from "./BracketContainer";
import PublishPanel from "./PublishPanel";
import {createBracket, updateBracket, getAdminBracket, getUserInfo} from "../../utilities/js/callouts/CalloutFactory";
import { getErrorToast, getInfoToast, getPublishSuccessToast, showErrorToast, showInfoToast, showSuccessToast } from "../../utilities/js/ToastHelper";
import Toast from '../../components/reusable/Toast';
import LoadingWall from "../../components/reusable/LoadingWall";
import {addRecentCreateBracket} from "../../utilities/js/localstorage/StorageHelper_CreateBrackets";
import {addRecentViewBracket} from "../../utilities/js/localstorage/StorageHelper_ViewBrackets";
import {getBracketDraft, setBracketDraft, storeDraftLocally} from "../../utilities/js/localstorage/StorageHelper_BracketDraft";
// import getURLParam from "../../utilities/js/ParameterRetrieval";
import { navigateToCreate, navigateToErrorPage } from "../../utilities/js/NavigationHelper";
import withRouter from "pages/withRouter";
import { freezeBody, unfreezeBody } from "utilities/js/styling/domUtilities";
import NavigationPanel from "components/reusable/NavigationPanel";
import NavigationTabs from "components/reusable/NavigationTabs";
import { NavigatorWrapper } from "components/reusable/NavigatorWrapper";

import CookieManager from "utilities/js/localstorage/CookieManager";
import Constants from "utilities/js/Constants";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { isLoggedIn } from "utilities/js/ActionLibrary";


const cookieManager = new CookieManager();

let TEMP_CONTESTANTS = [
    {name: "Person 1", seed: 1},
    {name: "Person 2", seed: 2},
    {name: "Person 3", seed: 3},
    {name: "Person 4", seed: 4}
];
const CreateBracketPage = (props) => {
    const bracketId = props?.params?.bracketId;

    const navigate = useNavigate();
    const queryClient = useQueryClient();

    let defaultContestantMap = {};
    TEMP_CONTESTANTS.forEach(contestant => {
        let id = generateUUID();
        defaultContestantMap[id] = {...contestant, id: id};
    })

    const [displaySettingsPanel, setDisplaySettingsPanel] = useState(false);
    const [displayPublishPanel, setDisplayPublishPanel] = useState(false);
    
    const [bracketSettings, setBracketSettings] = useState({
        tourneyName: 'Tournament Bracket',
        isDoubleElim: false,
        hideByes: false,
        roundSpacing: false,
        contestantMap: defaultContestantMap
    });

    // const [tourneyName, setTourneyName] = useState('Tournament Bracket');
    // const [isDoubleElim, setIsDoubleElim] = useState(false);
    // const [hideByes, setHideByes] = useState(false);
    // const [roundSpacing, setRoundSpacing] = useState(false);
    // const [contestantMap, setContestantMap] = useState(defaultContestantMap);
    const [brackets, setBrackets] = useState([]);
    const [defaultBracket, setDefaultBracket] = useState(null);
    const [defaultDoubleElimBracket, setDefaultDoubleElimBracket] = useState([]);
    const [toastMessages, setToastMessages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [viewOnlyBracketId, setViewOnlyBracketId] = useState(null);
    const [originalLoad, setOriginalLoad] = useState(false);
    const [originalLoadFinished, setOriginalLoadFinished] = useState(false);
    const [bracketRecord, setBracketRecord] = useState(false);
    const [userInfoLoaded, setUserInfoLoaded] = useState(false);
    

    const userInfoResponse = useQuery({
        queryKey: ['userInfo'], 
        queryFn: () => getUserInfo(cookieManager.getValue(Constants.COOKIE_USER_EMAIL_KEY)), 
        staleTime: Infinity,
        enabled: isLoggedIn() && !bracketId
    });

    if(userInfoResponse?.isSuccess && !userInfoLoaded && !defaultBracket){
        //If there is no default bracket in local storage or db, set the default elim based on user settings
            
            let updatedBracketSettings = Object.assign(bracketSettings, {
                isDoubleElim: userInfoResponse.data.doubleElim,
                hideByes: userInfoResponse.data.hideByes,
                roundSpacing: userInfoResponse.data.roundSpacing,
            });
            
            setBracketSettings(updatedBracketSettings);
            setUserInfoLoaded(true);
    }


    // useState(() => {
        if(!originalLoad){
            setOriginalLoad(true);
            getBracket();
        }
    // });
    
    async function getBracket(){
        setIsLoading(true);
        let result;
        try{
            if(bracketId){
                result = await getAdminBracket(bracketId);
            }else if(getBracketDraft()){
                //return the last one worked on from local storage if there's no specific id present
                result = getBracketDraft();
            }

            //if no result, just start from the default bracket
            if(result){
                setBracketSettings(Object.assign(bracketSettings, {
                    isDoubleElim: result.isDoubleElim,
                    tourneyName: result.title,
                    hideByes: result.hideByes,
                    roundSpacing: result.roundSpacing,
                    contestantMap: result.contestants
                }))
                setDefaultBracket(result.bracket);
                setDefaultDoubleElimBracket(result.doubleElimBracket);
                setViewOnlyBracketId(result.view_id);
                setBracketRecord(result);
                if(bracketId){
                    addRecentCreateBracket(bracketId, {title: result.title, lastdate: new Date().getTime()})
                }
            }
            setIsLoading(false);
            setOriginalLoadFinished(true);
            
        }catch(error){
            showErrorToast(this, 'Bracket does not exist');
            console.log('was unable to fetch bracket');
            navigateToErrorPage({errorType: 'bracketError'});
        }
    }
    
    async function publishBracket(){
        setIsLoading(true);
        
        let bracketInfo = {
            title: bracketSettings.tourneyName,
            isDoubleElim: bracketSettings.isDoubleElim,
            hideByes: bracketSettings.hideByes,
            roundSpacing: bracketSettings.roundSpacing,
            bracket: brackets.bracket,
            doubleElimBracket: brackets.doubleElimBracket,
            contestants: bracketSettings.contestantMap
        } 
        try{
            
            if(Object.keys(bracketSettings.contestantMap)?.length > 64){
                throw {code: 1, message: 'You cannot exceed 64 contestants in a published bracket.'};
            }

            let result = null;
            if(!bracketId){
                result = await createBracket(bracketInfo)
            }else{
                bracketInfo.bracketId = bracketId;;
                result = await updateBracket(bracketInfo);        
            }
            
            if(result.bracket_id){
                setViewOnlyBracketId(result.view_id);
                let updatedToasts = [...toastMessages];
                updatedToasts.push(getPublishSuccessToast());
                setToastMessages(updatedToasts);
                
                queryClient.invalidateQueries({ queryKey: ['brackets'] })
                // showSuccessToast(this);
                
                addRecentViewBracket(result.view_id, {title: result.title, lastdate: new Date().getTime()})
                addRecentCreateBracket(result.bracket_id, {title: result.title, lastdate: new Date().getTime()})
                if(!bracketId){
                    setBracketDraft(null);
                    setTimeout(() => {
                        navigateToCreate({bracketId:result.bracket_id, routerNav: navigate});
                    }, 2000);
                }
            }

        }catch(error){
            let message = 'There was an error publishing your bracket';
            if(error.code){
                message = error.message;
            }
            let updatedToasts = [...toastMessages];
            updatedToasts.push(getErrorToast(message));
            setToastMessages(updatedToasts);
            console.log(error);
        }finally{
            setTimeout(()=> {
                setIsLoading(false);
            }, 2000)
        }
    }    
    
    // *********************** Showing and hiding panels ***********************
    function openSettingsPanel(event){
        setDisplaySettingsPanel(true);
        setDisplayPublishPanel(false);
        freezeBody();
        event.stopPropagation();
    }
    
    function closeSettingsPanel(event){
        setDisplaySettingsPanel(false);
        unfreezeBody();
        event.stopPropagation();
    }
    
    function openPublishPanel(event){
        setDisplaySettingsPanel(false);
        setDisplayPublishPanel(true);
        freezeBody();
        event.stopPropagation();
    }
    
    function closePublishPanel(event){
        setDisplayPublishPanel(false);
        unfreezeBody();
        event.stopPropagation();
    }
    
    // *********************** Setting bracket-level settings ***********************
    function updateSetting(key, value){
        let updatedBracketSettings = {...bracketSettings};
        updatedBracketSettings[key] = value;
        setBracketSettings(updatedBracketSettings);
        if(key!='contestantMap'){
            saveDraft(updatedBracketSettings, brackets.bracket, brackets.doubleElimBracket);
        }
    }
    
    function storeBrackets(brackets){
        setBrackets(brackets);
        saveDraft(bracketSettings, brackets.bracket, brackets.doubleElimBracket);
    }

    function saveDraft(settings, bracket, doubleElimBracket){
        if(!bracketId){
            storeDraftLocally(settings, bracket, doubleElimBracket);
        }
    }
    
    // *********************** Handle Toast Messages from child components ***********************
    function handleToastMessage(message){
        let updatedToasts = [...toastMessages];
        updatedToasts.push(getInfoToast(message));
        setToastMessages(updatedToasts);
        // showInfoToast(this, message);
    }   

    function getSettingsPanel(){
        if(displaySettingsPanel){
            return (<div className="settings-panel">
                <SettingsPanel 
                    updateSetting={updateSetting}
                    defaults={bracketSettings}
                    contestantMap={bracketSettings.contestantMap} 
                    closePanel={closeSettingsPanel}
                    bracketId={bracketId} 
                    >
                </SettingsPanel>
            </div>);
        }
    }

    function getPublishPanel(){ 

        if(displayPublishPanel){
            return (
            <div className="settings-panel">
                <PublishPanel 
                closePanel={closePublishPanel} 
                publishBracket={publishBracket} 
                bracketId={viewOnlyBracketId} 
                showToast={handleToastMessage}
                ></PublishPanel>
            </div>);
        }
    }

    function getNavigationTabs(){

        if (isLoggedIn()) {
            return (<NavigationTabs hideDesktop="true" ></NavigationTabs>)
        }
    }

    // *********************** Render UI ***********************
            
    if(originalLoadFinished && !userInfoResponse.isLoading){
        return (
            <div> 
                <div className="bracket-page-container">
                    <NavigationPanel></NavigationPanel>                   
                    <BracketContainer 
                        format="tournament" 
                        settings={bracketSettings}
                        storeBrackets={storeBrackets} 
                        defaultBracket={defaultBracket} 
                        defaultDoubleElimBracket={defaultDoubleElimBracket} 
                        bracketRecord={bracketRecord}
                        onPublishClick={openPublishPanel}
                        onSettingsClick={openSettingsPanel} 
                    ></BracketContainer>
                </div>
                {getSettingsPanel()}
                {getPublishPanel()}
                <Toast toastList={toastMessages} position="top-left" autoDelete="true" autoDeleteTime="5000"/>
                <LoadingWall isLoading={isLoading}></LoadingWall>
                {getNavigationTabs()}
            </div>
        )
            
    }else{
        return (<LoadingWall isLoading={isLoading || !originalLoadFinished || userInfoResponse.isLoading}></LoadingWall>);
    }
}

export default withRouter(CreateBracketPage);


        